import React from 'react'

const RefundPolicy = () => {
  return (
    <div className="h-full w-full p-5">
      <h1 className="text-2xl text-primary pb-2 pt-4">Refund Policy</h1>
      <p className="text-sm">
        Please read the terms of service carefully before initiating any
        transaction and paying the fees for the mentorship program. Please note
        that you should not entertain any email/call/payment reference that is
        not sent to you from the official email id of the Devsnest
        (admin@devsnest.in) and does not have a payment page/link for
        transaction to Devsnest Private Limited. Please note that you are
        entitled to get a refund on your order within 7 days along with a reason
        for doing so and issue of a refund stands at the sole discretion of the
        management. The deadline for cancelling an order and availing a refund
        is 7 days from the date of payment. Please write to
        <span className="text-primary-light"> support@devsnest.in</span> in case
        of any queries related to this.
      </p>
    </div>
  )
}

RefundPolicy.seo = {
  title: 'Refund Policy | Devsnest',
  description:
    'We recommend that you read Devsnest\'s Refund Policy carefully. If you have any questions, please check out the "Contact Us" page.',
  canonical: 'https://devsnest.in/refund-policy',
  openGraph: {
    url: 'https://devsnest.in/refund-policy'
  }
}

export default RefundPolicy
